import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Box,
  Typography,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import DeleteIcon from '@mui/icons-material/Delete';

interface PermanentDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function PermanentDeleteModal({
  open,
  onClose,
  onConfirm,
}: PermanentDeleteModalProps) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        className: 'modal-dialog'
      }}
    >
      <DialogTitle>
        Aufgabe permanent löschen
      </DialogTitle>
      <DialogContent className="modal-content">
        <DialogContentText className="modal-content-text">
          <strong>Warnung:</strong> Sind Sie sicher, dass Sie diese Aufgabe permanent löschen
          möchten?
        </DialogContentText>
        <Box className="modal-error-box">
          <Typography className="modal-box-text modal-box-text-error">
            Diese Aktion kann nicht rückgängig gemacht werden! Die Aufgabe und alle zugehörigen
            Daten (Bilder, Dokumente, Zeiterfassung) werden vollständig gelöscht.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button 
          onClick={onClose}
          className="modal-button modal-button-cancel"
        >
          Abbrechen
        </Button>
        <Button
          onClick={onConfirm}
          className="modal-button modal-button-error"
        >
          <DeleteIcon className="modal-icon" />
          Permanent löschen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
